import React from 'react';
import { SimpleImage } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/items.d.ts').ArtistListingItem}
 */

const ArtistListingItem = ({
    listingMedia,
    role,
    swatch,
    title,
    url
}) => {

    return (
        <div className='expand-interaction'>
            {listingMedia?.video &&
                <video
                    autoPlay={true}
                    className='w-full'
                    loop={true}
                    muted={true}
                    playsInline={true}
                    poster={listingMedia.video.url}
                    src={listingMedia.video.src} />
            }

            {!listingMedia?.video && listingMedia?.image &&
                <SimpleImage
                    className='w-full'
                    {...listingMedia.image} />
            }
            <div className='px-16 py-8 flex'>
                <div
                    className='w-20 h-20'
                    style={{ backgroundColor: swatch}}/>
                <a
                    className='expand-interaction__action px-8'
                    href={url}>
                    {title}{role && `, ${role}`}
                </a>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ArtistListingItem;
